import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flexDirection: 'row'},
  left: {flex: 0.2, padding: 20},
  center: {flex: 0.5},
  right: {flex: 0.3, padding: 10},
  scrollContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  addNewBox: {
    backgroundColor: '#FACF47',
    padding: 10,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Simplified from a bordered+shadowed card per row to a flat, borderless
  // row with just a hover/selected tint - matches the plainer, flatter
  // language the rest of Study's redesign moved to (the flyouts' own rows)
  // instead of every row being its own mini card.
  participantsName: {
    paddingVertical: 9,
    paddingHorizontal: 12,
    marginHorizontal: 6,
    marginVertical: 1,
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'transparent',
    transitionProperty: 'background-color',
    transitionDuration: '0.12s',
  },
  hoveredName: {
    backgroundColor: CCColors.Primary.Light,
  },
  selectedName: {
    backgroundColor: updateColorWithOpacity(CCColors.Primary.Default, 0.14),
  },
  rowLeading: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1,
    marginRight: 8,
  },
  // Tinted fill instead of a white circle + colored ring - one visual
  // element per avatar instead of two.
  avatarCircle: {
    width: 26,
    height: 26,
    borderRadius: 13,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarCircleYou: {
    backgroundColor: CCColors.Workbook.DarkBrown,
  },
  avatarText: {
    fontSize: 11,
    fontWeight: '700',
  },
  avatarTextYou: {
    color: CCColors.Primary.Default,
  },
  // Owner/role indicators are now plain small text (see ParticipantRow) -
  // no boxed badges left to style here.
  // Compact segmented control for the owner's contributor/viewer toggle -
  // same shape/tokens as Study's settingsSubTabPill elsewhere on this page.
  roleToggleContainer: {
    flexDirection: 'row',
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 7,
    padding: 2,
    gap: 2,
    borderWidth: 1,
    borderColor: CCColors.Workbook.Beige,
  },
  roleTogglePill: {
    paddingHorizontal: 7,
    paddingVertical: 3,
    borderRadius: 5,
    transitionProperty: 'background-color',
    transitionDuration: '0.12s',
  },
  roleTogglePillActive: {
    backgroundColor: CCColors.Primary.Default,
  },
  actionButton: {
    width: 26,
    height: 26,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: 'background-color',
    transitionDuration: '0.15s',
  },
});
